import Vue from 'vue'
import EV3EditorViewItemHolder from '@broker/editorV3/ui/render/EV3EditorViewItemHolder.vue';


// we register globally to avoid recursive component issues
Vue.component('EV3EditorViewItemHolder', EV3EditorViewItemHolder)
